<template>
  <toast position="bottom-right" />

  <prime-dialog :header="dialog.title" v-model:visible="dialog.visible" :style="{ width: '96vw' }" :maximizable="true"
    :modal="true" class="mainDialog" :class="dialog.maximize ? 'p-dialog-maximized' : ''" :keepInViewport="false"
    :dismissableMask="true" @hide="onDialogHide">

    <component
      v-if="dialog.page !== ''"
      :key="`${dialog.page}-${dialog.sessionKey}`"
      :is="`page-${dialog.page}`"
      :data="dialog.data"
    />
  </prime-dialog>

  <div :class="containerClass" @click="onWrapperClick">
    <app-top-bar />
    <div class="layout-sidebar" @click="onSidebarClick">
      <router-link to="/">
        <img alt="Logo" src="../src/assets/img/logo_small.svg" width="65" height="auto" />
      </router-link>
      <button class="p-link layout-menu-button layout-topbar-button" @click="onMenuToggle">
        <i :class="menuIconClass"></i>
      </button>
      <app-menu :model="menu" @menuitem-click="onMenuItemClick" />
    </div>
    <div class="layout-main-container">
      <div class="layout-main" style="position:relative">
        <Loader v-if="loading" />
        <!-- <breadcrumb :home="breadcrumb.menu.home" :model="breadcrumb.menu.items" /> -->
        <router-view />
      </div>
      <app-footer />
    </div>
    <app-config :layoutMode="layoutMode" :layoutColorMode="layoutColorMode" @layout-change="onLayoutChange"
      @layout-color-change="onLayoutColorChange" />
    <transition name="layout-mask">
      <div class="layout-mask p-component-overlay" v-if="mobileMenuActive"></div>
    </transition>
  </div>
</template>
<script>
// import Profiles from '@/services/auth/auth.profile'
import Loader from '@/components/Loader.vue'
import AppTopBar from './AppTopbar.vue';
import AppMenu from './AppMenu.vue';
import AppConfig from './AppConfig.vue';
import AppFooter from './AppFooter.vue';
import { wizard } from '@/config/sites';
import PrimeDialog from 'primevue/dialog';
import PrimeButton from 'primevue/button';
import PageClientiMessaInMoraPec from '@/pages/ask/dialogs/operations/clienti/MessaInMoraPec.vue'
import PageClientiPreavviso from '@/pages/ask/dialogs/operations/clienti/Preavviso.vue'
import PageClientiSollecito from '@/pages/ask/dialogs/operations/clienti/Sollecito.vue'
import PageClientiInvitoAutolettura from '@/pages/ask/dialogs/operations/clienti/InvitoAutolettura.vue'

import PageContrattiVenditaAnomalie from '@/pages/ask/dialogs/operations/contratti-vendita/Anomalie.vue'
import PageContrattiVenditaModuloRid from '@/pages/ask/dialogs/operations/contratti-vendita/ModuloRid.vue'

import PageContrattiVenditaModificaMassiva from '@/pages/ask/dialogs/operations/contratti-vendita/ModificaMassiva.vue'
import PageContrattiVenditaInserimentoMassivoEe from '@/pages/ask/dialogs/operations/contratti-vendita/InserimentoMassivoEe.vue'
import PageContrattiVenditaInserimentoMassivoGas from '@/pages/ask/dialogs/operations/contratti-vendita/InserimentoMassivoGas.vue'

import PageFattureVenditaAggiungiDilazione from '@/pages/ask/dialogs/operations/fatture-vendita/AggiungiDilazione.vue'
import PageFatturaModificaDati from '@/pages/ask/dialogs/operations/fatture-vendita/ModificaDati.vue'
import PageFatturaModificaMassivaDati from '@/pages/ask/dialogs/operations/fatture-vendita/ModificaMassivaDati.vue'
import PageFatturaRiepilogoCicloMesi from '@/pages/ask/dialogs/operations/fatture-vendita/RiepilogoCicloMesi.vue'
import PageFattureVenditaExportDomesticiAziendeRappresentanti from '@/pages/ask/dialogs/operations/fatture-vendita/ExportDomesticiAziendeRappresentanti.vue'
import PageFattureVenditaCheckSddXml from '@/pages/ask/dialogs/operations/fatture-vendita/CheckSddXml.vue'
import PageFattureVenditaQuietanza from '@/pages/ask/dialogs/operations/fatture-vendita/Quietanza.vue'
import PageFattureVenditaInvioEmail from '@/pages/ask/dialogs/operations/fatture-vendita/InvioEmail.vue'
import PageFattureVenditaStorna from '@/pages/ask/dialogs/operations/fatture-vendita/Storna.vue'
import PageFattureVenditaImportCompensazioni from '@/pages/ask/dialogs/operations/fatture-vendita/ImportCompensazioni.vue'

import PagePdrsCambiaOfferta from '@/pages/ask/dialogs/operations/pdrs/CambiaOfferta.vue'
import PagePdrsGestioneLetture from '@/pages/ask/dialogs/operations/pdrs/GestioneLetture.vue'
import PagePdrsSospensioniRiattivazioni from '@/pages/ask/dialogs/operations/pdrs/SospensioniRiattivazioni.vue'
import PagePdrsAggiungiVociFatturaMassivo from '@/pages/ask/dialogs/operations/pdrs/AggiungiVociFatturaMassivo.vue'
import PagePdrsCaricaConsumiFile from '@/pages/ask/dialogs/operations/pdrs/CaricaConsumiFile.vue'
import PagePdrsCaricaLettureFile from '@/pages/ask/dialogs/operations/pdrs/CaricaLettureFile.vue'
import PagePdrsSospensioniSaldate from '@/pages/ask/dialogs/operations/pdrs/SospensioniSaldate.vue'

import PagePodsCambiaOfferta from '@/pages/ask/dialogs/operations/pods/CambiaOfferta.vue'
import PagePodsGestioneLetture from '@/pages/ask/dialogs/operations/pods/GestioneLetture.vue'
import PagePodsModificaMassiva from '@/pages/ask/dialogs/operations/pods/ModificaMassiva.vue'
import PagePodsSwitchIn from '@/pages/ask/dialogs/operations/pods/SwitchIn.vue'
import PagePodsMultipods from '@/pages/ask/dialogs/operations/pods/Multipods.vue'
import PagePodsMultipodsFile from '@/pages/ask/dialogs/operations/pods/MultipodsFile.vue'
import PageDialogVoltura from '@/pages/ask/dialogs/operations/pods/DialogVoltura.vue'
import PageDialogcreaCliente from '@/pages/ask/dialogs/operations/clienti/DialogcreaCliente.vue'
import PageMassivoSdi from '@/pages/ask/dialogs/operations/clienti/MassivoSdi.vue'
import PageReportInsertMassiveIban from '@/pages/ask/dialogs/operations/contratti-vendita/ReportInsertMassiveIban.vue'

import PagePdrsMultipdrs from '@/pages/ask/dialogs/operations/pdrs/Multipdrs.vue'
import PagePdrsMultipdrsFile from '@/pages/ask/dialogs/operations/pdrs/MultipdrsFile.vue'
import PagePodsDichiarazioneIva from '@/pages/ask/dialogs/operations/pods/DichiarazioneIva'
import PagePodsProspettoConsumi from '@/pages/ask/dialogs/operations/pods/ProspettoConsumi.vue'
import PagePodsRcuUnico from '@/pages/ask/dialogs/operations/pods/RcuUnico.vue'
import PagePdrsRcuUnico from '@/pages/ask/dialogs/operations/pdrs/RcuUnico.vue'
import PagePodsSommarioConsumiFornitori from '@/pages/ask/dialogs/operations/pods/SommarioConsumiFornitori.vue'
import PagePodsConsumiDispacciamento from '@/pages/ask/dialogs/operations/pods/ConsumiDispacciamento.vue'
import PagePodsSospensioniRiattivazioni from '@/pages/ask/dialogs/operations/pods/SospensioniRiattivazioni.vue'
import PagePodsAggiungiVociFatturaMassivo from '@/pages/ask/dialogs/operations/pods/AggiungiVociFatturaMassivo.vue'
import PagePodsCaricaConsumiFile from '@/pages/ask/dialogs/operations/pods/CaricaConsumiFile.vue'
import PagePodsSospensioniSaldate from '@/pages/ask/dialogs/operations/pods/SospensioniSaldate.vue'

import PageRappresentantiMultiProspettoCicloPagamenti from '@/pages/ask/dialogs/operations/rappresentanti/MultiProspettoCicloPagamenti.vue'

import PageAgentiUploadModulistica from '@/pages/ask/dialogs/operations/agenti/UploadModulistica.vue'
import PageAgentiReportPdp from '@/pages/ask/dialogs/operations/agenti/ReportPdp.vue'

import PageFattureAcquistoAggiungi from '@/pages/ask/dialogs/operations/fatture-acquisto/AggiungiFattura.vue'

export default {
  components: {
    PrimeDialog,
    PrimeButton,
    Loader,

    'AppTopBar': AppTopBar,
    'AppMenu': AppMenu,
    'AppConfig': AppConfig,
    'AppFooter': AppFooter,


    // Dialog Pages
    PageClientiMessaInMoraPec,
    PageClientiPreavviso,
    PageClientiSollecito,
    PageClientiInvitoAutolettura,

    PageContrattiVenditaAnomalie,
    PageContrattiVenditaModuloRid,
    PageContrattiVenditaModificaMassiva,
    PageContrattiVenditaInserimentoMassivoEe,
    PageContrattiVenditaInserimentoMassivoGas,

    PageFattureVenditaAggiungiDilazione,
    PageFatturaModificaDati,
    PageFatturaModificaMassivaDati,
    PageFatturaRiepilogoCicloMesi,
    PageFattureVenditaExportDomesticiAziendeRappresentanti,
    PageFattureVenditaCheckSddXml,
    PageFattureVenditaQuietanza,
    PageFattureVenditaInvioEmail,
    PageFattureVenditaStorna,
    PageFattureVenditaImportCompensazioni,

    PagePdrsCambiaOfferta,
    PagePdrsGestioneLetture,
    PagePdrsSospensioniRiattivazioni,
    PagePdrsAggiungiVociFatturaMassivo,
    PagePdrsCaricaConsumiFile,
    PagePdrsCaricaLettureFile,
    PagePdrsSospensioniSaldate,

    PagePodsCambiaOfferta,
    PagePodsGestioneLetture,
    PagePodsModificaMassiva,
    PagePodsSwitchIn,
    PagePodsMultipods,
    PagePodsMultipodsFile,
    PageDialogVoltura,
    PageDialogcreaCliente,
    PageReportInsertMassiveIban,
    PageMassivoSdi,
    PagePdrsMultipdrs,
    PagePdrsMultipdrsFile,
    PagePodsDichiarazioneIva,
    PagePodsProspettoConsumi,
    PagePodsRcuUnico,
    PagePdrsRcuUnico,
    PagePodsSommarioConsumiFornitori,
    PagePodsConsumiDispacciamento,
    PagePodsSospensioniRiattivazioni,
    PagePodsAggiungiVociFatturaMassivo,
    PagePodsCaricaConsumiFile,
    PagePodsSospensioniSaldate,

    PageRappresentantiMultiProspettoCicloPagamenti,

    PageAgentiUploadModulistica,
    PageAgentiReportPdp,

    PageFattureAcquistoAggiungi
  },

  data() {
    return {
      isMenuOpen: false,
      profiles: [],
      loading: false,
      pageName: '',
      layoutMode: 'static',
      layoutColorMode: 'light',
      staticMenuInactive: false,
      overlayMenuActive: false,
      mobileMenuActive: false,

      dialog: {
        page: '',
        title: '',
        data: null,
        visible: false,
        maximize: false,
        sessionKey: 0,

        // buttonOk:{
        //   label: '',
        //   icon: '',
        //   class: '',
        //   visible: false,
        //   disabled: false,
        // },

        // buttonCancel:{
        //   label: '',
        //   icon: '',
        //   class: '',
        //   visible: false,
        //   disabled: false,
        // },
      },

      menu: [
        {
          items: [
            { label: 'Home', icon: 'pi pi-home', to: '/home', profiles: ['all', 'vendita', 'contabilita', 'backoffice', 'credito', 'movimenti', 'acquisto', 'vendita', 'controllo', 'validazione','fatturazione_light','credito_light', 'assistenza_clienti'] },
            { label: "MindTab", icon: 'pi pi-th-large', to: '/ask/mind-tab', profiles: ['all', 'vendita', 'contabilita', 'backoffice', 'credito', 'movimenti', 'acquisto', 'vendita', 'controllo', 'assistenza_clienti'] },
            { label: 'In Call', icon: 'pi pi-check-circle', to: '/in-call', profiles: ['assistenza_clienti'] },

            //{label: 'Fatture Scadute', icon: 'pi pi-copy', to: '/fatture-vendita-scadute' , profiles:['all', 'credito']},
            // {label: 'Bilancio Fatt. Acquisto', icon: 'pi pi-chart-line', to: '/bilancio-fatture-acquisto' , profiles:['all', 'contabilita']},
            // {label: 'Cmor Controllo', icon: 'fas fa-money-check-alt fa-sm', to: '/cmor-invio' , profiles:['all','credito']},
            // {label: 'Preavvisi Invio', icon: 'pi pi-exclamation-triangle', to: '/preavvisi-invio' , profiles:['all','credito']},

            {
              label: 'Admin', icon: 'pi pi-book', profiles: ['all', 'vendita', 'contabilita', 'backoffice', 'credito', 'movimenti', 'acquisto', 'vendita', 'controllo'], items: [
                { label: 'Dashboard Grafici', icon: 'pi pi-chart-bar', to: '/dashboard', profiles: ['all', 'dashboard'] },
                { label: 'Previsionale Dispacciamento', icon: 'pi pi-cloud-download', to: '/previsionale-dispacciamento', profiles: ['all', 'backoffice'] },
                { label: 'Previsionale Incassi', icon: 'pi pi-dollar', to: '/previsionale-incassi', profiles: ['all'] },
                { label: 'Previsionale Uscite', icon: 'pi pi-dollar', to: '/previsionale-uscite', profiles: ['all', 'contabilita'] },
                { label: 'Prezzo Acquisto EE|GAS', icon: 'fas fa-money-bill-wave', to: '/prezzo-acquisto', profiles: ['all', 'pratiche'] },
                { label: 'Preview Fatturato', icon: 'pi pi-images', to: '/preview-fatturato', profiles: ['all', 'credito'] },
                { label: 'Report Pod', icon: 'pi pi-book', to: '/report-pod', profiles: ['all', 'credito'] },
                { label: 'Andamento CAB', icon: 'pi pi-chart-bar', to: '/andamento-cab', profiles: ['all', 'credito'] },
                { label: 'Info Ticket', icon: 'pi pi-ticket', to: '/info-ticket', profiles: ['all'] },
                { label: 'Pannello Funzionalità', icon: 'pi pi-cog', to: '/pannello-funzionalita', profiles: ['all'] },
                { label: 'Documentazione', icon: 'pi pi-book', to: '/documentazione', profiles: ['all'] },
                { label: 'Utenti e Permessi', icon: 'pi pi-lock', to: '/permessi', profiles: ['all'] },
              ]
            },

            {
              label: 'Backoffice', icon: 'pi pi-book', profiles: ['all', 'vendita', 'contabilita', 'backoffice', 'credito', 'movimenti', 'acquisto', 'vendita', 'controllo', 'assistenza_clienti'], items: [
                { label: 'Sosp/Riatt Pratiche', icon: 'far fa-share-square', to: '/sospensioni-riattivazioni', profiles: ['all', 'credito', 'backoffice'] },
                { label: 'Bonus Sociale', icon: 'pi pi-thumbs-up', to: '/bonus-sociale', profiles: ['all', 'backoffice', 'credito'] },
                { label: 'Costi Pratiche', icon: 'fas fa-wrench', to: '/costi-pratiche', profiles: ['all', 'backoffice', 'credito'] },
                { label: 'Check Rcu', icon: 'pi pi-book', to: '/RcuCheck', profiles: ['all', 'pratiche', 'backoffice', 'credito', 'assistenza_clienti'] },
                { label: 'AutoLettura', icon: 'pi pi-file', to: '/AutoLettura', profiles: ['all', 'pratiche', 'backoffice', 'credito', 'contabilita', 'assistenza_clienti'] },
                { label: 'Controllo Consumi', icon: 'pi pi-exclamation-triangle', to: '/controllo-consumi', profiles: ['all', 'credito'] },
                { label: "Moduli RID", icon: 'pi pi-copy', to: '/elenco-moduli-rid', profiles: ['all', 'contabilita', 'backoffice', 'credito', 'movimenti', 'acquisto', 'vendita', 'controllo'] },
                { label: 'Riepilogo Gettoni', icon: 'fas fa-id-badge', to: '/riepilogo-gettoni', profiles: ['all', 'pratiche', 'backoffice'] },
                { label: 'Controllo Voci in Fattura', icon: 'fas fa-id-badge', to: '/controllo-voci-fattura', profiles: ['all', 'backoffice', 'assistenza_clienti'] },
              ]
            },

            //{ label: 'Bilancio', icon: 'pi pi-dollar', to: '/bilancio', profiles: ['all','contabilita'] },
            // {label: 'Sosp/Riatt Preview', icon: 'far fa-hourglass', to: '/preview-sospensioni-riattivazioni' , profiles:['all', 'credito', 'backoffice']},

            {
              label: 'Pratiche', icon: 'pi pi-book', profiles: ['all', 'vendita', 'contabilita', 'backoffice', 'credito', 'movimenti', 'acquisto', 'vendita', 'controllo','credito_light', 'assistenza_clienti'], items: [
                {
                  label: 'Gestione Pratiche', icon: 'pi pi-copy', to: '/gestione-pratiche', profiles: ['all', 'pratiche', 'backoffice', 'credito', 'assistenza_clienti']
                },
                {
                  label: 'Gestione PdC', icon: 'pi pi-send', profiles: ['all', 'pratiche', 'backoffice', 'credito'], items: [
                    {
                      label: 'Invia PdC', icon: 'pi pi-send', to: '/gestione-pdc/invia', profiles: ['all', 'pratiche', 'backoffice', 'credito']
                    },
                    {
                      label: 'Statistiche', icon: 'pi pi-chart-bar', to: '/gestione-pdc/statistiche', profiles: ['all', 'pratiche', 'backoffice', 'credito']
                    },
                    {
                      label: 'Fix PdC', icon: 'pi pi-wrench', to: '/gestione-pdc/fix', profiles: ['all', 'pratiche', 'backoffice', 'credito']
                    },
                  ]
                },
                {
                  label: 'Gestione Preventivi Pratiche', icon: 'pi pi-copy', to: '/gestione-preventivi-pratiche', profiles: ['all', 'pratiche', 'backoffice', 'credito']
                },
                // { label: 'Switch-in', icon: 'fas fa-random', to: '/switch-in', profiles: ['all', 'pratiche'] },
                // { label: 'Switch-in Caricati', icon: 'fas fa-random', to: '/switch-in/caricati', profiles: ['all', 'pratiche', 'backoffice'] },
                {
                  label: 'Switch-out', icon: 'fas fa-reply-all', to: '/switch-out', profiles: ['all', 'pratiche', 'backoffice', 'credito', 'assistenza_clienti']
                },
                {
                  label: 'Switch-out Credito', icon: 'fas fa-reply-all', to: '/swoutCredito', profiles: ['all', 'pratiche', 'backoffice', 'credito','credito_light']
                },
                {
                  label: 'Previsionale', icon: 'fas fa-chart-line', to: '/previsionale', profiles: ['all', 'pratiche', 'backoffice']
                },

                { label: 'Cmor | Messe in Mora', icon: 'fas fa-comments-dollar', to: '/cmor', profiles: ['all', 'credito', 'backoffice'] },
                { label: 'Cmor Invio', icon: 'fas fa-money-check-alt fa-sm', to: '/cmor-invio', profiles: ['all','credito'] },
                { label: 'Cmor Giornaliere', icon: 'fas fa-comments-dollar', to: '/cmor-giornaliere', profiles: ['all', 'credito'] },
                { label: 'Ann./Sosp. Notifiche Cmor', icon: 'pi pi-exclamation-triangle', to: '/clienti-in-uscita', profiles: ['all', 'pratiche'] },
                { label: 'Richieste Massive', icon: 'pi pi-calendar', to: '/operazioni-massive', profiles: ['all', 'backoffice'] },

              ]
            },

            // {label: 'Check Recessi', icon: 'pi pi-directions-alt', to: '/check-recessi' , profiles:['all', 'pratiche']},
            // {label: 'Controllo Rid', icon: 'pi pi-check-square', to: '/controllo-rid' , profiles:['all', 'backoffice', 'credito']},

            {
              label: 'Credito', icon: 'pi pi-wallet', profiles: ['all', 'vendita', 'contabilita', 'backoffice', 'credito', 'movimenti', 'acquisto', 'vendita', 'controllo', 'credito_light', 'assistenza_clienti'], items: [
                { label: 'In Call', icon: 'pi pi-check-circle', to: '/in-call', profiles: ['all', 'credito', 'credito_light','backoffice', 'assistenza_clienti'] },
                { label: 'Recupera Credito', icon: 'pi pi-check-circle', to: '/recupero-credito', profiles: ['all', 'credito', 'credito_light'] },
                { label: 'Credito', icon: 'pi pi-id-card', to: '/CreditoView', profiles: ['all', 'contabilita', 'credito','credito_light'] },                { label: 'Info Validazione Credito', icon: 'pi pi-info-circle', to: '/info-validazione-credito', profiles: ['all', 'credito'] },
                { label: 'Riepilogo Mensile Insoluti', icon: 'pi pi-check-circle', to: '/riepilogo-mensile-insoluti', profiles: ['all', 'credito','credito_light', 'assistenza_clienti'] },
                { label: 'Riepilogo Insoluti Agenti', icon: 'pi pi-check-circle', to: '/riepilogo-insoluti-agenti', profiles: ['all', 'credito','credito_light'] },
                { label: 'Riepilogo Pagamenti', icon: 'pi pi-money-bill', to: '/riepilogo-pagamenti', profiles: ['all', 'credito', 'assistenza_clienti'] },
                { label: 'Riepilogo Provvigione', icon: 'fas fa-id-badge', to: '/riepilogo-provvigioni', profiles: ['all', 'pratiche'] },
                { label: 'Qualità Agenti Firmatari', icon: 'fas fa-id-badge', to: '/qualitaFirmatari', profiles: ['all'] },
                { label: 'Fatture Vendita', icon: 'pi pi-copy', to: '/fatture-vendita', profiles: ['all', 'contabilita'] },
                { label: 'Fatture Scadute', icon: 'pi pi-copy', to: '/fatture-scadute-one-year', profiles: ['all', 'contabilita', 'credito'] },
                { label: 'Preavvisi Solleciti Sospensioni', icon: 'pi pi-exclamation-triangle', to: '/preavvisi-sosp-solleciti', profiles: ['all', 'credito', 'assistenza_clienti'] },
                { label: 'Sospensioni | Riattivazioni', icon: 'pi pi-exclamation-triangle', to: '/sospensioni-riattivazioni-forniture', profiles: ['all', 'credito', 'pratiche', 'backoffice', 'assistenza_clienti'] },
                { label: 'Rilascio Tutela', icon: 'pi pi-exclamation-triangle', to: '/rilascio-tutela', profiles: ['all', 'pratiche', 'backoffice', 'assistenza_clienti'] },
                { label: 'Contabili', icon: 'pi pi-id-card', to: '/contabili', profiles: ['all', 'contabilita', 'credito', 'assistenza_clienti'] },
                { label: 'Controllo Storni Rid', icon: 'pi pi-check-square', to: '/controllo-storni-rid', profiles: ['all', 'backoffice','credito', 'assistenza_clienti'] },
                { label: 'Riepilogo Mensile Rid', icon: 'pi pi-check-square', to: '/riepilogo-mensile-rid', profiles: ['all', 'contabilita', 'backoffice'] },
                { label: 'Andamento Agenti', icon: 'fas fa-id-badge', to: '/andamento-agenti', profiles: ['all', 'backoffice', 'credito'] },
                // { label: 'Non Sospendibili', icon: 'fas fa-user-slash', to: '/non-sospendibili', profiles: ['all', 'credito'] },
              ]
            },

            {
              label: 'Info', icon: 'pi pi-info-circle', profiles: ['all', 'vendita', 'contabilita', 'backoffice', 'credito', 'movimenti', 'acquisto', 'vendita', 'controllo', 'assistenza_clienti'], items: [
                { label: 'Crediti Usciti', icon: 'pi pi-euro', to: '/CreditiUsciti', profiles: ['all', 'contabilita', 'credito'] },
                { label: 'Info Punti Distacco', icon: 'pi pi-euro', to: '/InfoPraticheDossier', profiles: ['all', 'contabilita', 'credito'] },
                { label: 'Info Lista Per Codici Conto', icon: 'pi pi-euro', to: '/InfoCodiciConto', profiles: ['all', 'contabilita'] },
                { label: 'Rid Sdd Allianz', icon: 'pi pi-euro', to: '/RidSddAllianz', profiles: ['all', 'admin', 'contabilita', 'fatturazione','backoffice'] },
                { label: 'Rid Sdd Banche', icon: 'pi pi-credit-card', to: '/RidSddBanche', profiles: ['all', 'admin', 'contabilita'] },
                { label: 'Info Richiesta Rimborsi', icon: 'pi pi-money-bill', to: '/InfoRichiestaRimborsi', profiles: ['all', 'contabilita', 'backoffice', 'credito','fatturazione_light','fatturazione', 'assistenza_clienti'] },
              ]
            },

            {
              label: 'Billing', icon: 'pi pi-euro', profiles: ['all', 'vendita', 'contabilita', 'backoffice', 'credito', 'movimenti', 'acquisto', 'vendita', 'controllo','fatturazione_light', 'assistenza_clienti'],
              items: [
                { label: 'Fatturazione', icon: 'pi pi-id-card', to: '/FatturazioneView', profiles: ['all', 'contabilita', 'credito', 'backoffice', 'assistenza_clienti'] },
                { label: 'RID', icon: 'pi pi-copy', to: '/clienti/fatture/rid/in-scadenza', profiles: ['all', 'contabilita'] },
                { label: 'SDI', icon: 'pi pi-copy', to: '/clienti/fatture/sdi', profiles: ['all', 'contabilita'] },
                { label: 'Genera Fatture Energia', icon: 'pi pi-copy', to: '/clienti/fatture/energia/genera', profiles: ['all', 'contabilita'] },
                { label: 'Genera Fatture Gas', icon: 'pi pi-copy', to: '/clienti/fatture/gas/genera', profiles: ['all', 'contabilita'] },
                { label: 'Controlla Dilazioni', icon: 'pi pi-copy', to: '/controlla/dilazioni', profiles: ['all', 'contabilita', 'credito', 'assistenza_clienti'] },
                { label: 'Controlla Solleciti', icon: 'pi pi-copy', to: '/clienti/solleciti', profiles: ['all', 'contabilita', 'credito'] },
                { label: 'Controlla Preavvisi', icon: 'pi pi-copy', to: '/clienti/preavvisi', profiles: ['all', 'contabilita', 'credito'] },
                { label: 'Controlla Note Credito', icon: 'pi pi-copy', to: '/clienti/note-credito', profiles: ['all', 'credito', 'assistenza_clienti'] },
                { label: 'Pun', icon: 'pi pi-money-bill', to: '/pun', profiles: ['all', 'admin'] },
                { label: 'Fatture Acquisto', icon: 'pi pi-copy', to: '/fatture', profiles: ['all', 'contabilita'] },
                { label: 'Bilancio Fatt. Fornitori', icon: 'pi pi-wallet', to: '/bilancio-fatture-fornitori', profiles: ['all', 'contabilita', 'backoffice'] },
                { label: 'Control Fatture Fornitori | ee', icon: 'pi pi-book', to: '/controllo-fatture-fornitori/ee', profiles: ['all', 'contabilita','credito'] },
                { label: 'Control Fatture Fornitori | gas', icon: 'pi pi-book', to: '/controllo-fatture-fornitori/gas', profiles: ['all', 'contabilita','credito'] },
                { label: 'Controllo Acquistato Venduto', icon: 'pi pi-sort', to: '/controllo-acquistato-venduto', profiles: ['all', 'contabilita','credito'] },
                { label: 'Analisi Fornitori', icon: 'pi pi-chart-bar', to: '/analisi-fornitori', profiles: ['all', 'contabilita'] },
                { label: 'Tariffe ee', icon: 'pi pi-euro', to: '/tariffe-ee', profiles: ['all', 'admin', 'contabilita','credito'] },
                { label: 'Tariffe gas', icon: 'pi pi-euro', to: '/tariffe-gas', profiles: ['all', 'admin', 'contabilita','credito'] },
                { label: 'Fattura Voci', icon: 'pi pi-list', to: '/fattura-voci', profiles: ['all', 'credito', 'contabilita'] },
                { label: 'Bonus Basilicata', icon: 'pi pi-list', to: '/bonus-basilicata', profiles: ['all', 'credito', 'credito_light'] },

                // {label: 'Controlla Messa In Mora', icon: 'pi pi-copy', to: '/clienti/messa-in-mora', profiles:['all', 'contabilita', 'credito']}, 
              ]
            },

            {
              label: 'Tesoreria', icon: 'pi pi-copy', profiles: ['all', 'vendita', 'contabilita', 'backoffice', 'credito', 'movimenti', 'acquisto', 'vendita', 'controllo', 'assistenza_clienti'],
              items: [
                { label: 'Estratti Conto', icon: 'pi pi-id-card', to: '/estratti-conto', profiles: ['all', 'contabilita', 'assistenza_clienti'] },
                { label: 'Controlli Estratti Conto', icon: 'pi pi-check-square', to: '/controlli-estratto-banca', profiles: ['all', 'contabilita', 'assistenza_clienti'] },
                { label: 'Controllo Pagamenti', icon: 'pi pi-euro', to: '/controllo-pagamenti', profiles: ['all', 'contabilita', 'assistenza_clienti'] },
                { label: 'Gestione movimenti ignoti', icon: 'pi pi-users', to: '/estratti-conto/gestione-movimenti-ignoti', profiles: ['all', 'contabilita', 'assistenza_clienti'], userIds: [20, 25, 36, 43, 65, 64, 61, 55, 52, 4, 11, 29, 34, 41, 42] },
                { label: 'AGYO Statistiche', icon: 'pi pi-copy', to: '/tesoreria/statistiche-agyo', profiles: ['all', 'contabilita', 'backoffice'] },
                { label: 'Banche - Codici Conto', icon: 'pi pi-copy', to: '/tesoreria/banche-e-codici-conto', profiles: ['all', 'contabilita'] },
                { label: 'Codici IVA', icon: 'pi pi-copy', to: '/tesoreria/codici-iva', profiles: ['all', 'contabilita'] },
                { label: 'Saldi Bilancio', icon: 'pi pi-copy', to: '/tesoreria/bilancio/saldi', profiles: ['all', 'contabilita'] },
                { label: 'Fornitori - Conti Acquisto', icon: 'pi pi-copy', to: '/tesoreria/fornitori/conti-acquisto', profiles: ['all', 'contabilita'] },
                { label: 'Bollo', icon: 'pi pi-copy', to: '/tesoreria/fornitori/bollo', profiles: ['all', 'contabilita'] },
                { label: 'MindTab Fornitori', icon: 'pi pi-th-large', to: '/tesoreria/mindtab-fornitori', profiles: ['all', 'contabilita', 'acquisto'] },
                { label: 'Controllo Fatture Acquisti', icon: 'pi pi-book', to: '/controllo-fatture-acquisto', profiles: ['all', 'contabilita'] },
                {
                  label: 'Dogane', icon: 'pi pi-money-bill', profiles: ['all', 'contabilita'], items: [
                    { label: 'Fornitori', icon: 'fas fa-wave-square', to: '/fornitori-dogane', profiles: ['all', 'contabilita'] },
                    { label: 'Accise', icon: 'pi pi-money-bill', to: '/accise-dogane', profiles: ['all', 'contabilita'] },
                    { label: 'Invii telematici', icon: 'pi pi-send', to: '/invii-telematici-dogane', profiles: ['all', 'contabilita'] },
                  ]
                },
              ]
            },
            // { label: 'Tickets', icon: 'pi pi-ticket', to: '/tickets', profiles: ['all', 'vendita', 'contabilita', 'backoffice', 'credito', 'movimenti', 'acquisto', 'vendita', 'controllo'] },
            // { label: 'Ftp', icon: 'far fa-folder-open', to: '/ftp', profiles: ['all', 'vendita', 'contabilita', 'backoffice', 'credito', 'movimenti', 'acquisto', 'vendita', 'controllo'] },
            // { label: 'Impostazioni', icon: 'pi pi-cog', to: '/impostazioni', profiles: ['all', 'settings'] },
            { label: 'Ticket', icon: 'pi pi-ticket', to: '/tickets', profiles: ['all', 'vendita', 'contabilita', 'backoffice', 'credito', 'credito_light','movimenti', 'acquisto', 'vendita', 'controllo', 'assistenza_clienti'], class: 'ticket-menu-item' },
            { label: 'Vai a Wizard', icon: 'pi pi-external-link', url: wizard.url, target: '_blank', profiles: ['all', 'vendita', 'contabilita', 'backoffice', 'credito', 'credito_light', 'movimenti', 'acquisto', 'controllo', 'assistenza_clienti'] },
            // { label: 'Logout', icon: 'pi pi-sign-out', click: this.showConfirmDialog, profiles: ['all', 'vendita', 'contabilita', 'backoffice', 'credito', 'movimenti', 'acquisto', 'vendita', 'controllo'], class: 'logout-menu-item' },
          ]
        },
      ],

      breadcrumb: {
        menu: {
          home: { icon: 'pi pi-fw pi-home', to: '/home', styleClass: 'text-white', },
          items: [
            {
              label: 'Home',
              styleClass: 'text-white',
            },
          ]

        }
      },
    }
  },
  created() {

    this.$eventBus.on('show-dialog-page', this.showDialogPage)
    this.$eventBus.on('dialog-return-ok-button', this.returnOkDialog)
    this.$eventBus.on('dialog-return-cancel-button', this.returnCancelDialog)

    this.$eventBus.on('page-change', (evt) => {
      this.breadcrumb.menu.items = [{ label: evt.currentRoute.name }]
    })

    this.$eventBus.on('data-global-loading', () => {
      this.loading = true
    })

    this.$eventBus.on('data-global-loaded', () => {
      this.loading = false
    })

    this.$eventBus.on('data-load-success', (evt) => {
      this.$toast.add({
        severity: 'success',
        summary: 'Successo',
        detail: `${evt.message}`,
        life: 4000
      })
      // this.loading = false
    })

    this.$eventBus.on('data-load-error', (evt) => {
      this.$toast.add({
        severity: 'warn',
        summary: 'Error Message',
        detail: `message: ${evt.message} url: ${evt.url}`,
        life: 4000
      })
      //   this.loading = false
    })

    this.$eventBus.on('menu-toggle', (event) => {
      this.menuClick = true;
      if (this.isDesktop()) {
        if (this.layoutMode === 'overlay') {
          if (this.mobileMenuActive === true) {
            this.overlayMenuActive = true;
          }

          this.overlayMenuActive = !this.overlayMenuActive;
          this.mobileMenuActive = false;
        } else if (this.layoutMode === 'static') {
          this.staticMenuInactive = !this.staticMenuInactive;
        }
      } else {
        this.mobileMenuActive = !this.mobileMenuActive;
      }

      event.preventDefault();
    })

  },

  methods: {
    showConfirmDialog() {
      this.$confirm.require({
        message: 'Vuoi effettuare il logout?',
        header: 'Conferma',
        icon: 'pi pi-info-circle',
        accept: () => {
          this.handleLogout();
        },
        reject: () => {
          // Opzionale: azioni da eseguire se l'utente rifiuta
        }
      });
    },
    handleLogout() {
      this.$store.dispatch("auth/logout").then(
        () => {
          this.$router.push("/login");  // Reindirizza l'utente alla pagina di login
        },
        (error) => {
          console.error(error);  // Stampa eventuali errori nella console
        }
      );
    },
    showDialogPage(evt) {
      this.dialog.sessionKey += 1
      this.dialog.page = evt.page
      this.dialog.title = evt.title
      this.dialog.maximize = evt.maximize

      this.dialog.data = evt.data

      // this.dialog.buttonOk.label = evt.buttonOk.label,
      // this.dialog.buttonOk.icon = evt.buttonOk.icon,
      // this.dialog.buttonOk.classCss = evt.buttonOk.classCss,
      // this.dialog.buttonOk.visible = evt.buttonOk.visible
      // this.dialog.buttonOk.disabled = evt.buttonOk.disabled,

      // this.dialog.buttonCancel.label = evt.buttonCancel.label,
      // this.dialog.buttonCancel.icon = evt.buttonCancel.icon,
      // this.dialog.buttonCancel.classCss = evt.buttonCancel.classCss,
      // this.dialog.buttonCancel.visible = evt.buttonCancel.visible
      // this.dialog.buttonCancel.disabled = evt.buttonCancel.disabled,

      this.dialog.visible = true
    },
    onMenuToggle(event) {
      this.isMenuOpen = !this.isMenuOpen;
      console.log('Menu toggled:', this.isMenuOpen); // Aggiunto per debug
      this.$eventBus.emit('menu-toggle', event); // Usa this per accedere all'eventBus in modo corretto
    },
    onOkDialog() {
      // console.log(this.dialog.page)
      //this.dialog.buttonOk.disabled = true
      // this.$eventBus.emit(`dialog-page-${this.dialog.page}-ok-button`, {})
    },
    menuIconClass() {
      return this.isMenuOpen ? 'pi pi-arrow-right' : 'pi pi-arrow-left';
    },
    returnOkDialog() {
      // this.dialog.buttonOk.disabled = false
      // this.dialog.visible = false

      // this.dialog.page = ''
      // this.dialog.title = ''

      // this.dialog.data = null

      // this.dialog.buttonOk.visible = false
      // this.dialog.buttonCancel.visible = false
    },

    onCancelDialog() {
      this.$eventBus.emit(`dialog-page-${this.dialog.page}-cancel-button`, {})
    },

    onDialogHide() {
      this.dialog.page = ''
      this.dialog.title = ''
      this.dialog.data = null
    },

    returnCancelDialog() {
      this.dialog.visible = false;

      this.dialog.page = ''
      this.dialog.title = ''

      this.dialog.data = null

      // this.dialog.buttonOk.visible = false
      // this.dialog.buttonCancel.visible = false
    },

    onWrapperClick() {
      if (!this.menuClick) {
        this.overlayMenuActive = false
        this.mobileMenuActive = false
      }

      this.menuClick = false
    },

    onSidebarClick() {
      this.menuClick = true;
    },

    onMenuItemClick(event) {
      if (event.item && !event.item.items) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
      }
    },

    onLayoutChange(layoutMode) {
      this.layoutMode = layoutMode;
    },

    onLayoutColorChange(layoutColorMode) {
      this.layoutColorMode = layoutColorMode;
    },

    addClass(element, className) {
      if (element.classList) {
        element.classList.add(className)
      } else {
        element.className += ' ' + className
      }
    },

    removeClass(element, className) {
      if (element.classList) {
        element.classList.remove(className)
      } else {
        element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ')
      }
    },

    isDesktop() {
      return window.innerWidth >= 992;
    },

    isSidebarVisible() {
      if (this.isDesktop()) {
        if (this.layoutMode === 'static') {
          return !this.staticMenuInactive
        } else if (this.layoutMode === 'overlay') {
          return this.overlayMenuActive
        }
      }

      return true;
    }
  },

  computed: {
    containerClass() {
      return ['layout-wrapper',
        {
          'layout-overlay': this.layoutMode === 'overlay',
          'layout-static': this.layoutMode === 'static',
          'layout-static-sidebar-inactive': this.staticMenuInactive && this.layoutMode === 'static',
          'layout-overlay-sidebar-active': this.overlayMenuActive && this.layoutMode === 'overlay',
          'layout-mobile-sidebar-active': this.mobileMenuActive,
          'p-input-filled': this.$primevue.config.inputStyle === 'filled',
          'p-ripple-disabled': this.$primevue.config.ripple === false,
          'layout-theme-light': this.$appState.theme.startsWith('saga'),
        }
      ]
    },

    logo() {
      return (this.layoutColorMode === 'dark') ? "images/logo-white.svg" : "images/logo.svg"
    }
  },

  watch: {
    $route() {
      this.menuActive = false;
      this.$toast.removeAllGroups()
    },
  },

  beforeUpdate() {
    if (this.mobileMenuActive) {
      this.addClass(document.body, 'body-overflow-hidden')
    } else {
      this.removeClass(document.body, 'body-overflow-hidden')
    }
  },

}
</script>

<style lang="scss">
// @import './App.scss';
.mainDialog .p-dialog-content {
  display: flex;
  width: 100%;
  justify-content: center;
  min-height: 500px;
  padding-bottom: 90px;
  overflow-y: overlay;
}

.mainDialog .page {
  height: 100%;
  width: 100%;
}

.p-breadcrumb {
  margin-bottom: 20px;
}

.ticket-menu-item {
  margin-top: 60px;
  font-size: 15px;
  background-color: var(--blue-800);
}

.icon-logout {
  transform: rotate(-90deg);
}

.layout-menu-button {
  display: flex;
  /* Abilita Flexbox */
  align-items: center;
  /* Allinea l'icona verticalmente */
  margin-right: 10px;
}

.layout-sidebar {
  display: flex;
  flex-direction: column;
}

.email-box {
  display: flex;
  justify-content: center;
  align-items: center;
}

.p-breadcrumb {
  margin: 0;
  padding: 0;
  color: white !important;
  margin-top: 5px;
  font-size: 14px !important;
}

.p-breadcrumb-home {
  color: white !important;
}

.breadcrumb-container {
  width: 60%;
  margin: 0 auto;
  display: flex;
  justify-content: flex-start;
  color: white;
  margin-top: 20px;
}

.layout-menu-button {
  display: block;
}
</style>
